<template>
  <div class="koc-block koc-payment-list-block">
    <template v-if="profiles && profiles.length">
      <div
        v-for="profile in profiles"
        :key="profile.id"
        class="koc-card koc-split"
      >
        <div
          v-if="profile.vault === 'authorizenet'"
          class="koc-authorizenet"
        >
          <div
            v-if="profile.type === 'visa'"
            class="float-left koc-image"
          >
            <img src="@/assets/images/visa.png">
          </div>
          <div
            v-else-if="profile.type === 'master'"
            class="float-left koc-image"
          >
            <img src="@/assets/images/master.png">
          </div>
          <div
            v-else-if="profile.type === 'american_express'"
            class="float-left koc-image"
          >
            <img src="@/assets/images/amex.png">
          </div>
          <div
            v-else
            class="float-left koc-image"
          >
            <img src="@/assets/images/cc-generic.png">
          </div>
          <div class="float-left koc-details">
            <span>
              {{ profile.masked }}
              <br>
              <span v-if="profile.status === 'active'">
                Expires: {{ profile.expiration.month }}/{{
                  profile.expiration.year
                }}
              </span>
            </span>
          </div>
          <div class="float-left koc-details">
            <span v-if="isDefault(profile, defaultProfile, selectedProfile)" />
            <span
              v-if="profile.status === 'expired'"
              class="koc-expired"
            >Expired</span>
            <span
              v-if="isSelected(profile, selectedProfile) && showActivationOptions"
              class="koc-current"
            >Active</span>
          </div>
          <div class="float-right koc-actions">
            <button
              v-if="
                profile.status === 'active' &&
                  !isSelected(profile, selectedProfile) &&
                  showActivationOptions
              "
              class="koc-button koc-secondary koc-small"
              @click="
                state.confirmDelete = null;
                activate(profile);
              "
            >
              Use
            </button>
            <button
              class="koc-button koc-danger koc-small"
              @click="state.confirmDelete = profile"
            >
              Delete
            </button>
          </div>
          <div
            v-if="state.confirmDelete && profile.id === state.confirmDelete.id"
            class="koc-clear koc-confirm"
          >
            <template
              v-if="isDefault(profile, defaultProfile, selectedProfile)"
            >
              <p class="koc-full">
                This payment method is currently the active payment method for
                your existing KelbyOne Membership.
                <br>
                Removing this payment method may prevent us from automatically
                collecting payment at your next renewal, unless you update your
                payment method for the existing subscription.
              </p>
              <button
                class="koc-button koc-secondary koc-small koc-danger"
                @click="
                  state.confirmDelete = null;
                  remove(profile);
                "
              >
                I understand, Delete this payment method
              </button>
              <button
                class="koc-button koc-secondary koc-small"
                @click="state.confirmDelete = null"
              >
                Cancel
              </button>
            </template>

            <template v-else>
              <p class="koc-full">
                Delete this payment method? If it's your primary one, another will be used. If none are available, your subscription will expire at the end of the payment period.
              </p>
              <button
                class="koc-button koc-danger koc-small"
                @click="
                  state.confirmDelete = null;
                  remove(profile);
                "
              >
                Confirm Delete
              </button>
              <button
                class="koc-button koc-secondary koc-small"
                @click="state.confirmDelete = null"
              >
                Cancel
              </button>
            </template>
          </div>
        </div>
        <div
          v-if="profile.vault === 'braintree_blue'"
          class="koc-braintree"
        >
          <div class="float-left koc-image">
            <img src="@/assets/images/paypal.png">
          </div>
          <div class="float-left koc-details">
            <span>
              {{ profile.details.first }} {{ profile.details.last }}
              {{ profile.details.email }}
            </span>
          </div>
          <div class="float-left koc-details">
            <span
              v-if="profile.status === 'expired'"
              class="koc-expired"
            >Expired</span>
            <span
              v-if="isSelected(profile, selectedProfile)"
              class="koc-current"
            >Current</span>
          </div>
          <div class="float-right koc-actions">
            <button
              v-if="
                profile.status === 'active' &&
                  !isSelected(profile, selectedProfile) && showActivationOptions
              "
              class="koc-button koc-secondary koc-small"
              @click="
                state.confirmDelete = null;
                activate(profile);
              "
            >
              Use
            </button>
            <button
              class="koc-button koc-danger koc-small"
              @click="state.confirmDelete = profile"
            >
              Delete
            </button>
          </div>
          <div
            v-if="state.confirmDelete && profile.id === state.confirmDelete.id"
            class="koc-clear koc-confirm"
          >
            <template
              v-if="isDefault(profile, defaultProfile, selectedProfile)"
            >
              <p class="koc-full">
                This payment method is currently the active payment method for
                your existing KelbyOne Membership.
                <br>
                Removing this payment method may prevent us from automatically
                collecting payment at your next renewal, unless you update your
                payment method for the existing subscription.
              </p>
              <button
                class="koc-button koc-secondary koc-small koc-danger"
                @click="
                  state.confirmDelete = null;
                  remove(profile);
                "
              >
                I understand, Delete this payment method
              </button>
              <button
                class="koc-button koc-secondary koc-small"
                @click="state.confirmDelete = null"
              >
                Cancel
              </button>
            </template>

            <template v-else>
              <p class="koc-full">
                Delete this payment method? If it's your primary one, another will be used. If none are available, your subscription will expire at the end of the payment period.
              </p>
              <button
                class="koc-button koc-danger koc-small"
                @click="
                  state.confirmDelete = null;
                  remove(profile);
                "
              >
                Confirm Delete
              </button>
              <button
                class="koc-button koc-secondary koc-small"
                @click="state.confirmDelete = null"
              >
                Cancel
              </button>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="koc-card koc-split">
        <div class="float-left koc-details">
          <span> No Existing Payment Methods Available. </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script src="./list.js"></script>
<style lang="scss" scoped src="./list.scss"></style>
